var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('one-field-date-time',{staticClass:"mt-0 pt-0",attrs:{"label":_vm.label,"icon":"today","value":_vm.date,"rules":_vm.rules,"clearable":""},on:{"input":_vm.emitDateTimeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }